export default "__VITE_ASSET__DxhFsQT3__"